import { Box, Flex, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { AreaChart, Area, ResponsiveContainer } from 'recharts'
import { useChartTheme } from '../../../hooks/useChartTheme'
import { brand } from '../../../theme'
import TrendIndicator from './TrendIndicator'
import type { KpiData } from '../../../data/mockEstadisticas'

const MotionBox = motion.create(Box)

interface KpiCardProps {
  data: KpiData
  index: number
}

export default function KpiCard({ data, index }: KpiCardProps) {
  const { colors, card } = useChartTheme()
  const sparklineData = data.sparkline.map((v) => ({ value: v }))
  const invertColor = data.id === 'transito' || data.id === 'incidencias'

  return (
    <MotionBox
      bg={card.bg}
      backdropFilter={card.backdropFilter}
      border="1px solid"
      borderColor={card.border}
      borderRadius="2xl"
      p={5}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      boxShadow={card.boxShadow}
      position="relative"
      overflow="hidden"
    >
      {/* Sparkline background */}
      <Box position="absolute" bottom={0} left={0} right={0} h="50px" opacity={0.15}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={sparklineData}>
            <defs>
              <linearGradient id={`spark-${data.id}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={brand.green} stopOpacity={0.8} />
                <stop offset="100%" stopColor={brand.green} stopOpacity={0} />
              </linearGradient>
            </defs>
            <Area
              type="monotone"
              dataKey="value"
              stroke={brand.green}
              fill={`url(#spark-${data.id})`}
              strokeWidth={1.5}
              dot={false}
              isAnimationActive={false}
            />
          </AreaChart>
        </ResponsiveContainer>
      </Box>

      {/* Content */}
      <Box position="relative" zIndex={1}>
        <Text
          fontSize="10px"
          textTransform="uppercase"
          letterSpacing="0.2em"
          fontWeight="bold"
          color={colors.textMuted}
          mb={2}
        >
          {data.label}
        </Text>
        <Flex alignItems="baseline" gap={2} mb={2}>
          <Text fontSize="2xl" fontWeight="bold" color={colors.text}>
            {data.value.toLocaleString()}
          </Text>
          {data.unit && (
            <Text fontSize="sm" fontWeight="500" color={colors.textMuted}>
              {data.unit}
            </Text>
          )}
        </Flex>
        <TrendIndicator value={data.trend} direction={data.trendDirection} invertColor={invertColor} />
      </Box>
    </MotionBox>
  )
}
